<template>
    <div class="fuwu-info-operate">
        <div class="common-header-wrap">
            <mt-header title="经营设置" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
		<div class='main-content'>
			<div @click="onClass"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">服务分类</span></flex-line></div>
			<flex-line :show-border="true" class="range range-start">
			    <span>开始时间</span>
				<div slot="right" class="timeright">
					<mt-range
							v-model="timeStart"
							:min="0"
							:max="2880"
							:step="30"
							:bar-height="5">
						<div class="range-right" slot="end">{{formatTime(timeStart)}}</div>
					</mt-range>
				</div>
			</flex-line>
			<flex-line :show-border="true" class="range range-start">
			    <span>结束时间</span>
				<div slot="right" class="timeright">
					<mt-range
							v-model="timeEnd"
							:min="0"
							:max="2880"
							:step="30"
							:bar-height="5">
						<div class="range-right" slot="end">{{formatTime(timeEnd)}}</div>
					</mt-range>
				</div>
			</flex-line>
			<flex-line class="menu-item" :show-border="true"><span class="field-line field-name">收款账号</span><div class="field-line-right" slot="right"><input type='textarea' class="field-input" v-model="user.organization_payment_account" /></div></flex-line>
			<flex-line class="menu-item" :show-border="true"><span class="field-line field-name">简介</span><div class="field-line-right" slot="right"><input type='textarea' class="field-input" v-model="user.organization_detail" /></div></flex-line>
			<div class="common-btn mint-button--primary ds-button-large mt-10" @click='submit'>保存</div>
		</div>

        <!--服务分类-->
        <mt-popup v-model="classVisible" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="服务分类" class="common-header">
                    <mt-button slot="left" icon="back" @click="onClass"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <mt-checklist
                        class="video-tag wrap"
                        :max="3"
                        v-model="classValue"
                        :options="classOptions">
                </mt-checklist>
                <mt-button type="primary" @click='confirmClass' size="large">确定</mt-button>
            </div>
        </mt-popup>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { editInfoOperate } from '../../../api/fuwuManageInfo'
import { getClassTree } from '../../../api/fuwuClass'
import { Toast } from 'mint-ui'
import flexLine from '../../flexLine'
export default {
	components: {
		  flexLine
	},
  name: 'Index',
  data () {
    return {
      class_name: '',
      class_id_1: 0,
      class_name_1: '',
      class_id_2: 0,
      class_name_2: '',
      class_id_3: 0,
      class_name_3: '',
      timeStart: 0,
      timeEnd: 2880,
      classVisible: false,
      classValue: [],
      classOptions: [],
      classList: {}
    }
  },
  created: function () {
    getClassTree().then(res => {
      let classList = res.result.o2o_fuwu_class_list
      for (var i in classList) {
        if (classList[i].o2o_fuwu_class_parent_id != 0) {
          continue
        }
        this.classList[classList[i].o2o_fuwu_class_id + ''] = classList[i]
        this.classOptions.push({
          label: classList[i].o2o_fuwu_class_name,
          value: classList[i].o2o_fuwu_class_id + ''
        })
      }
      if (this.user.class_id_1 && typeof (this.classList[this.user.class_id_1 + '']) !== 'undefined') {
        this.classValue.push(this.user.class_id_1 + '')
      }
      if (this.user.class_id_2 && typeof (this.classList[this.user.class_id_1 + '']) !== 'undefined') {
        this.classValue.push(this.user.class_id_2 + '')
      }
      if (this.user.class_id_3 && typeof (this.classList[this.user.class_id_1 + '']) !== 'undefined') {
        this.classValue.push(this.user.class_id_3 + '')
      }
    })
    this.timeStart = this.user.organization_open_start
    this.timeEnd = this.user.organization_open_end
    if (this.user.class_name_1) {
      this.class_name = this.user.class_name_1
      this.class_id_1 = this.user.class_id_1
      this.class_name_1 = this.user.class_name_1
    }
    if (this.user.class_name_2) {
      this.class_name += '、' + this.user.class_name_2
      this.class_id_2 = this.user.class_id_2
      this.class_name_2 = this.user.class_name_2
    }
    if (this.user.class_name_3) {
      this.class_name += '、' + this.user.class_name_3
      this.class_id_3 = this.user.class_id_3
      this.class_name_3 = this.user.class_name_3
    }
  },
  computed: {
    ...mapState({
      user: state => state.fuwu.info
    })
  },
  watch: {
    timeEnd: function (timeEnd) {
      if (timeEnd < this.timeStart) {
        this.timeEnd = this.timeStart
      }
    },
    timeStart: function (timeStart) {
      if (timeStart > this.timeEnd) {
        this.timeStart = this.timeEnd
      }
    }
  },
  methods: {
    ...mapMutations({
      fuwuEdit: 'fuwuEdit'
    }),
    confirmClass () {
      this.class_id_1 = 0
      this.class_name_1 = ''
      this.class_id_2 = 0
      this.class_name_2 = ''
      this.class_id_3 = 0
      this.class_name_3 = ''
      if (this.classValue.length > 3) {
        Toast('最多选3个')
        return false
      }
      for (var i in this.classValue) {
        switch (i) {
          case '0':
            this.class_id_1 = this.classValue[i]
            this.class_name_1 = this.classList[this.classValue[i]].o2o_fuwu_class_name
            this.class_name = this.class_name_1
            break
          case '1':
            this.class_id_2 = this.classValue[i]
            this.class_name_2 = this.classList[this.classValue[i]].o2o_fuwu_class_name
            this.class_name += '、' + this.class_name_2
            break
          case '2':
            this.class_id_3 = this.classValue[i]
            this.class_name_3 = this.classList[this.classValue[i]].o2o_fuwu_class_name
            this.class_name += '、' + this.class_name_3
            break
        }
      }

      this.classVisible = false
    },
    onClass () {
      if (!this.classVisible) {
        this.classVisible = true
      } else {
        this.classVisible = false
      }
    },
    submit () {
      let data = {
        organization_open_start: this.timeStart,
        organization_open_end: this.timeEnd,
        class_id_1: this.class_id_1,
        class_name_1: this.class_name_1,
        class_id_2: this.class_id_2,
        class_name_2: this.class_name_2,
        class_id_3: this.class_id_3,
        class_name_3: this.class_name_3,
        organization_detail: this.user.organization_detail,
        organization_payment_account: this.user.organization_payment_account
      }
      editInfoOperate(data).then(res => {
        this.fuwuEdit(data)
        if (this.$route.query.from == 'register') {
          this.$router.push({ name: 'FuwuManageAuthen', query: { from: 'register' } })
        } else {
          Toast(res.message)
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    formatTime (time) {
      time = parseInt(time)
      let hour = parseInt(time / 60)
      if (hour < 10) {
        hour = '0' + hour
      } else if (hour > 23) {
        hour = hour - 24
        if (hour < 10) {
          hour = '次日0' + hour
        } else {
          hour = '次日' + hour
        }
      }
      let minute = time % 60
      if (minute < 10) {
        minute = '0' + minute
      }
      return hour + ':' + minute
    }
  }
}
</script>

<style lang="scss">
	.main-content{background: #fff;padding:0 $pageSpace}
	.fuwu-info-operate .range .timeright{display: flex;flex: 1;}
	.mint-radiolist {
	    display: flex;
	.mint-cell {
	    flex: 1;
	.mint-radio-input:checked + .mint-radio-core {
	    background-color: #ff9900 !important;
	    border-color: #ff9900 !important;
	}
	}
	}
    .fuwu-info-operate .range .mint-cell-value{flex:2;position:relative}
    .fuwu-info-operate .range .mt-range {
        width: 100%;
    }
	.fuwu-info-operate .range .right{flex: 2;}
    .fuwu-info-operate .range .mt-range .range-right{width:4rem}
    .fuwu-info-operate .range-start .mt-range-runway{border-top-color: #26a2ff;}
    .fuwu-info-operate .range-start .mt-range-progress{background-color:#a9acb1}
	
</style>
